// extracted by mini-css-extract-plugin
export default {"historyWidget":"historyWidget_historyWidget__XH1UD"};